export default "__VITE_ASSET__QCDcCbQw__"